import isUndefinedNullOrEmpty from '@ahd/shared/tools/is-undefined-null-or-empty';

import checkIfUrlIsSourceLink from 'src/modules/fahrzeugsuche/helpers/check-if-url-is-source-link';

export default function pathIsDetailViewUrl(location: Pick<Location, 'pathname' | 'search'>, disableSeoRoutes: boolean, searchPath: string): boolean {
    const isSourceUrl = checkIfUrlIsSourceLink(location, disableSeoRoutes, searchPath);
    const urlIsDetailView = (disableSeoRoutes === true ? location?.search?.match(/[?&].*_carId([0-9]+)/) : location?.pathname?.match(/\/c\/.*\/([0-9]+)/))?.[1];

    return !isUndefinedNullOrEmpty(isSourceUrl) || !isUndefinedNullOrEmpty(urlIsDetailView);
}
